export default __webpack_public_path__ + "static/media/PASMA_LOGO_white.9bb7e290.png";